/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { LeadViewLogBody } from '../models';
// @ts-ignore
import { PostLeadViewLog201Response } from '../models';
/**
 * LeadViewLogApi - axios parameter creator
 * @export
 */
export const LeadViewLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * リードビューログ作成API
         * @summary リードビューログ作成API
         * @param {LeadViewLogBody} [leadViewLogBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeadViewLog: async (leadViewLogBody?: LeadViewLogBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/lead_view_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadViewLogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadViewLogApi - functional programming interface
 * @export
 */
export const LeadViewLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadViewLogApiAxiosParamCreator(configuration)
    return {
        /**
         * リードビューログ作成API
         * @summary リードビューログ作成API
         * @param {LeadViewLogBody} [leadViewLogBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLeadViewLog(leadViewLogBody?: LeadViewLogBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLeadViewLog201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLeadViewLog(leadViewLogBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LeadViewLogApi - factory interface
 * @export
 */
export const LeadViewLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadViewLogApiFp(configuration)
    return {
        /**
         * リードビューログ作成API
         * @summary リードビューログ作成API
         * @param {LeadViewLogBody} [leadViewLogBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeadViewLog(leadViewLogBody?: LeadViewLogBody, options?: any): AxiosPromise<PostLeadViewLog201Response> {
            return localVarFp.postLeadViewLog(leadViewLogBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadViewLogApi - interface
 * @export
 * @interface LeadViewLogApi
 */
export interface LeadViewLogApiInterface {
    /**
     * リードビューログ作成API
     * @summary リードビューログ作成API
     * @param {LeadViewLogBody} [leadViewLogBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadViewLogApiInterface
     */
    postLeadViewLog(leadViewLogBody?: LeadViewLogBody, options?: AxiosRequestConfig): AxiosPromise<PostLeadViewLog201Response>;

}

/**
 * Request parameters for postLeadViewLog operation in LeadViewLogApi.
 * @export
 * @interface LeadViewLogApiPostLeadViewLogRequest
 */
export interface LeadViewLogApiPostLeadViewLogRequest {
    /**
     * 
     * @type {LeadViewLogBody}
     * @memberof LeadViewLogApiPostLeadViewLog
     */
    readonly leadViewLogBody?: LeadViewLogBody
}

/**
 * LeadViewLogApi - object-oriented interface
 * @export
 * @class LeadViewLogApi
 * @extends {BaseAPI}
 */
export class LeadViewLogApi extends BaseAPI implements LeadViewLogApiInterface {
    /**
     * リードビューログ作成API
     * @summary リードビューログ作成API
     * @param {LeadViewLogApiPostLeadViewLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadViewLogApi
     */
    public postLeadViewLog(requestParameters: LeadViewLogApiPostLeadViewLogRequest = {}, options?: AxiosRequestConfig) {
        return LeadViewLogApiFp(this.configuration).postLeadViewLog(requestParameters.leadViewLogBody, options).then((request) => request(this.axios, this.basePath));
    }
}
